export function AppHeightChecker() {
  return (
    <div
      id="app-height-checker"
      style={{
        height: "100vh",
        width: "100%",
        pointerEvents: "none",
        position: "fixed",
      }}
    />
  )
}
